import React from 'react';
import useCollapse from 'react-collapsed';

import Minus from 'components/Icons/Minus';
import Plus from 'components/Icons/Plus';
import User from 'components/Icons/User';

import { useLoginContext } from '../context';
import Dropdown from './Dropdown';
import * as Styled from './styled';

/**
 * LoggedIn properties
 */
export type ComponentProps = {};

/**
 * This component renderes when user is logged in the system
 */
const LoggedIn: React.FC<ComponentProps> = () => {
  const { setIsLoggedIn, authManager } = useLoginContext();
  const showDropdown = false; // TODO: ADD THE MISSING DROPDOWN ITEMS WHEN A SPEC WILL BE MADE
  // const [showDropdown, setShowDropdown] = useState(false);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded: showDropdown });

  const onClickHandler = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    await authManager.signOut();
    setIsLoggedIn(false);
    // setShowDropdown(!showDropdown);
  };

  /**
   * event handler when the login button is clicked
   */
  // const onLogout = async (e: React.FormEvent<EventTarget>) => {
  //   e.preventDefault();
  //   await authManager.signOut();
  //   setIsLoggedIn(false);
  // };
  // return (
  //   <Styled.Wrapper onClick={onLogout}>
  //     <Styled.Button>
  //       <Styled.LoginWrapper>
  //         <Styled.IconWrapper>
  //           <User />
  //         </Styled.IconWrapper>
  //         <Styled.Text>Logged in</Styled.Text>
  //       </Styled.LoginWrapper>
  //     </Styled.Button>
  //   </Styled.Wrapper>
  // );

  return (
    <Styled.Wrapper>
      <Styled.Button {...getToggleProps({ onClick: onClickHandler })} onClick={onClickHandler}>
        <Styled.LoginLeftWrapper>
          <Styled.UserIconWrapper>
            <User />
          </Styled.UserIconWrapper>
          <Styled.Text>Logged in</Styled.Text>
        </Styled.LoginLeftWrapper>
        <Styled.LoginRightWrapper>
          <Styled.IconWrapper>{showDropdown ? <Minus /> : <Plus />}</Styled.IconWrapper>
        </Styled.LoginRightWrapper>
      </Styled.Button>
      {showDropdown && (
        <Styled.Content {...getCollapseProps()}>
          <Dropdown />
        </Styled.Content>
      )}
    </Styled.Wrapper>
  );
};

export default LoggedIn;
